import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';

import { AuthStateService } from './auth-state.service';
import { AuthService } from './auth.service';

export function permissionGuard(permission: string): CanActivateFn {
  return (_route, state) => {
    const auth = inject(AuthService);
    const authState = inject(AuthStateService);
    const router = inject(Router);

    return auth.ensureSession().pipe(
      map((authenticated) => {
        if (!authenticated) {
          return router.createUrlTree(['/login'], {
            queryParams: { returnUrl: state.url },
          });
        }

        if (authState.hasPermission(permission)) {
          return true;
        }

        return router.createUrlTree(['/acesso-negado'], {
          queryParams: {
            permission,
            returnUrl: state.url,
          },
        });
      }),
    );
  };
}


export function anyPermissionGuard(
  permissions: string[],
): CanActivateFn {
  return (_route, state) => {
    const auth = inject(AuthService);
    const authState = inject(AuthStateService);
    const router = inject(Router);

    return auth.ensureSession().pipe(
      map((authenticated) => {
        if (!authenticated) {
          return router.createUrlTree(['/login'], {
            queryParams: { returnUrl: state.url },
          });
        }

        if (authState.hasAnyPermission(permissions)) {
          return true;
        }

        return router.createUrlTree(['/acesso-negado'], {
          queryParams: {
            permission: permissions.join(' ou '),
            returnUrl: state.url,
          },
        });
      }),
    );
  };
}
